import DataTable, { TableColumn } from 'react-data-table-component';
import { JSX } from 'react';

import FlexContainer from 'global_elements/Layouts/FlexContainer';
import InlineText from 'global_elements/Text/InlineText';
import { ReactComponent as SortIcon } from 'icons/mho-sort-icon-white.svg';

import { PixSubmittedDataRow, PixSubmittedTableProps } from 'types/tableProps';
import { AlignVariant, DisplayVariant, JustifyVariant } from 'global_elements/Layouts/FlexContainer/variants';
import { FontColors, FontSizes } from 'global_elements/Text/variants';

import { AlternatingBasicTableStyle } from '../styles';

const NoDataComponent: JSX.Element = <InlineText text="No Data Found." fontColor={FontColors.PRIMARY} fontSize={FontSizes.LARGE} />;

const columns = (): TableColumn<PixSubmittedDataRow>[] => {
  const cols: TableColumn<PixSubmittedDataRow>[] = [
    {
      name: '',
      selector: (row) => row.year,
      sortable: true,
    },
    {
      name: 'Jan',
      selector: (row) => row.Jan,
      sortable: true,
    },
    {
      name: 'Feb',
      selector: (row) => row.Feb,
      sortable: true,
    },
    {
      name: 'Mar',
      selector: (row) => row.Mar,
      sortable: true,
    },
    {
      name: 'Apr',
      selector: (row) => row.Apr,
      sortable: true,
    },
    {
      name: 'May',
      selector: (row) => row.May,
      sortable: true,
    },
    {
      name: 'Jun',
      selector: (row) => row.Jun,
      sortable: true,
    },
    {
      name: 'Jul',
      selector: (row) => row.Jul,
      sortable: true,
    },
    {
      name: 'Aug',
      selector: (row) => row.Aug,
      sortable: true,
    },
    {
      name: 'Sep',
      selector: (row) => row.Sep,
      sortable: true,
    },
    {
      name: 'Oct',
      selector: (row) => row.Oct,
      sortable: true,
    },
    {
      name: 'Nov',
      selector: (row) => row.Nov,
      sortable: true,
    },
    {
      name: 'Dec',
      selector: (row) => row.Dec,
      sortable: true,
    },
    {
      name: 'YTD',
      selector: (row) => row.YTD,
      sortable: true,
    },
  ];

  return cols;
};

const PIXSubmittedTable = (props: PixSubmittedTableProps): JSX.Element => (
  <FlexContainer display={DisplayVariant.FLEX_COL} justify={JustifyVariant.CENTER} align={AlignVariant.END} extraClasses="pix-submitted-table">
    <DataTable dense persistTableHead sortIcon={<SortIcon />} customStyles={AlternatingBasicTableStyle} columns={columns()} data={props.data} noDataComponent={NoDataComponent} />
  </FlexContainer>
);

export default PIXSubmittedTable;
